import { FetchedWasteTypes } from "./api/sanity/types";

export const isValidWasteType = (
  sanityWasteTypes: FetchedWasteTypes,
  wasteType: string,
) => {
  return sanityWasteTypes.map((wt) => wt.id).includes(wasteType);
};
